<template>
    <div class="infos">
        <h1>Mes informations personnelles</h1>
            <b-container>
                <b-row>
                    <b-col sm="12" md="6" align-self="end" class="user-identity">
                        <b-row>
                            <b-col class="user-label" align-self="start">
                                Genre&nbsp;: 
                            </b-col>
                            <b-col align-self="start">
                                {{ user.gender }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="user-label" align-self="center">
                                Nom d'usage&nbsp;: 
                            </b-col>
                            <b-col align-self="center">
                                {{ user.last_name }}
                            </b-col>
                        </b-row>
                        <b-row v-if="user.birth_name && user.birth_name!='' && user.birth_name!=='null'">
                            <b-col class="user-label" align-self="center">
                                Nom de naissance&nbsp;: 
                            </b-col>
                            <b-col align-self="center">
                                {{ user.birth_name }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="user-label" align-self="center">
                                Prénom&nbsp;: 
                            </b-col>
                            <b-col align-self="center">
                                {{ user.first_name }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="user-label" align-self="center">
                                Date de naissance&nbsp;: 
                            </b-col>
                            <b-col align-self="center">
                                {{ user.birth_date }}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="user-label" align-self="center">
                                Lieu de naissance&nbsp;: 
                            </b-col>
                            <b-col align-self="center">
                                {{ user.birthPlace }}
                            </b-col>
                        </b-row>
                        <b-row id="edit-personal-infos">
                            <b-alert show variant="primary">
                                Pour modifier vos informations personnelles ci-dessus, veuillez contacter votre tuteur.
                            </b-alert>
                        </b-row>
                        <b-row id="db-btn">
                            <dashboard-link-button></dashboard-link-button>
                        </b-row>
                    </b-col>
                    <b-col sm="12" md="6">

                        <b-form @submit.prevent="onSubmit">
                            <b-form-group 
                                id="input-group-email" 
                                label="Email :" 
                                label-for="input-email"
                            >
                                <b-form-input
                                    id="input-email"
                                    type="email"
                                    v-model="accountForm.email"
                                    placeholder="Entrez votre adresse email"
                                    value=""
                                    :state="email.state"
                                    @blur="isValidEmail"
                                ></b-form-input>
                                <b-form-invalid-feedback id="input-email-feedback">
                                    L'adresse renseignée ne respecte pas le format email.
                                </b-form-invalid-feedback>
                            </b-form-group>

                            <b-form-group
                                id="input-group-new-password"
                                label="Nouveau mot de passe :"
                                label-for="input-new-password"
                            >
                                <b-form-input
                                    id="input-new-password"
                                    type="password"
                                    v-model="accountForm.new_password"
                                    placeholder="Entre 8 et 30 caractères"
                                    value=""
                                    maxlength="30"
                                    :disabled="disabledPwd"
                                    :state="new_password.state"
                                    @blur="checkNewPwd"
                                ></b-form-input>
                                <b-form-invalid-feedback id="input-new-pwd-feedback">
                                    Votre nouveau mot de passe doit contenir entre 8 et 30 caractères.
                                </b-form-invalid-feedback>
                                <b-form-text id="input-new-pwd-help" variant="dark">
                                    Pour modifier votre mot de passe, vous devez renseigner et confirmer une adresse email. Une fois votre mot de passe modifié, l'adresse email renseignée deviendra votre identifiant de connexion.
                                </b-form-text>
                            </b-form-group>

                            <b-form-group id="input-group-confirm-password" label="Confirmez le nouveau mot de passe :" label-for="input-confirm-password">
                                <b-form-input
                                    id="input-confirm-password"
                                    type="password"
                                    v-model="accountForm.confirm_password"
                                    placeholder="Veuillez confirmer le nouveau mot de passe"
                                    value=""
                                    maxlength="30"
                                    :disabled="disabledPwd"
                                    :state="confirm_password.state"
                                    @blur="checkConfirmPwd"
                                ></b-form-input>
                                <b-form-invalid-feedback id="input-confirm-pwd-feedback">
                                    La confirmation ne correspond pas au nouveau mot de passe renseigné.
                                </b-form-invalid-feedback>
                            </b-form-group>

                            <b-form-group id="input-group-password" label="Mot de passe actuel (obligatoire) :" label-for="input-password">
                                <span class="pwd-field">
                                    <b-form-input
                                        id="input-password"
                                        :type="current_password.type"
                                        v-model="accountForm.password"
                                        placeholder="Entrez ici votre mot de passe actuel"
                                        required
                                        maxlength="30"
                                        :state="current_password.state"
                                        class="input"
                                    ></b-form-input>
                                    <b-button @click="showPassword()" v-b-tooltip.hover title="Afficher le mot de passe">
                                        <b-icon-eye-fill v-if="current_password.show"></b-icon-eye-fill>
                                        <b-icon-eye-slash-fill v-else></b-icon-eye-slash-fill>
                                    </b-button>
                                </span>
                                <b-form-invalid-feedback id="input-confirm-pwd-feedback">
                                    Vous devez renseigner votre mot de passe actuel pour enregistrer vos modifications.
                                </b-form-invalid-feedback>
                            </b-form-group>

                        <b-alert
                            :show="showAlert()"
                            fade
                            :variant="alertVariant"
                            class="top-0 end-0 alert-box"
                        >
                            {{ alertMessage }}
                        </b-alert>
                            <b-button type="submit" variant="success" class="text-white">Enregistrer les modifications</b-button>
                        </b-form>
                    </b-col>
                </b-row>
            </b-container>

        <b-card bg-variant="info" text-variant="dark" border-variant="dark">
            En conformité avec les exigences du Réglement Général sur la Protection des données (RGPD), nous vous informons que nous nous tenons à votre disposition pour toute demande portant sur vos droits d'accès, de rectification et d'opposition concernant vos données personnelles à l'adresse email <a href="mailto:technique@icdlfrance.org" class="text-secondary">technique@icdlfrance.org</a>.
        </b-card>
    </div>
</template>

<script>
import Store from '@/store/index.js'
import api from '@/services/api.js'
import DashboardLinkButton from '../components/DashboardLinkButton.vue'

export default {
  components: { DashboardLinkButton },
  methods: {
      onSubmit() {
        let checkInputs = this.isValidEmail() && this.checkNewPwd() && this.checkConfirmPwd()
        if (!checkInputs) {return}

        return new Promise((resolve, reject) => {
            this.$parent.$parent.setLoading(true, "Enregistrement des modifications")
            this.alertVariant = 'light'
            this.alertMessage = ''
            api.patch('/user/edit', this.accountForm)
            .then(response=> {
                this.alertVariant = 'success'
                this.alertMessage = 'Les modifications ont été enregistrées avec succès.'
                if(response.data[0].emailSent==true) {
                    this.alertMessage += " Un lien de vérification vient d'être envoyé par email à l'adresse que vous avez renseigné. Veuillez vous rendre sur ce lien afin de confirmer votre adresse email."
                }
                this.accountForm.password = ''
                Store.dispatch('update_email', response.data[0].email)
                this.$parent.$parent.setLoading(false)
                resolve(response);
            })
            .catch(error => {
                this.alertVariant = 'danger'
                if(error.response.status==400) {
                    this.alertMessage = "Une erreur est survenue. Veuillez vérifier les informations renseignées."
                } else {
                    this.alertMessage = error.response.data.error.exception[0].message
                }
                this.$parent.$parent.setLoading(false)
                reject(error)
            })
            .then(this.showAlert())
        })

      },
      showAlert() {
          if (this.alertMessage == '') return false
          else return true
      },
      formattedDate(date) {
          return date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear()
      },
      checkNewPwd() {
          if (this.accountForm.new_password !== '') {
            if (this.accountForm.new_password.trim().length < 8 || this.accountForm.new_password.trim().length > 30) {
              this.new_password.state = false
              return false
            } else {
              this.new_password.state = true
              return true
            }
          } else {
              this.new_password.state = null
              return true
            }
      },
      checkConfirmPwd() {
          if (this.accountForm.new_password == '') {
              this.confirm_password.state = null
              return true
          }
          else if (this.accountForm.new_password !== this.accountForm.confirm_password) {
              this.confirm_password.state = false
              return false
          } else {
              this.confirm_password.state = true
              return true
          }
      },
      isValidEmail(){
        if (this.accountForm.email == '') {
            this.email.state = null
            return true
        }
        else if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.accountForm.email)) {
            this.email.state = true
            return true
        } else {
            this.email.state = false
            return false
        } 
      },
    IsPassword() {
        if (this.accountForm.password.trim() == '') {
            this.current_password.state = false
            return false
        } else {
            this.current_password.state = null
            return true
        }
    },
    showPassword() {
        if (this.current_password.show === false) {
            this.current_password.show = true
            this.current_password.type = "text"
        } else {
            this.current_password.show = false
            this.current_password.type = "password"          
        }
    }
  },
  data () {
    return {
        name: 'Infos',
        accountForm: {
            new_password: '',
            confirm_password: '',
            email: '',
            password: ''
        },
        email: {
            state: null,
            feedback: null
        },
        new_password: {
            state: null,
            feedback: null
        },
        confirm_password: {
            state: null,
            feedback: null
        },
        current_password: {
            state: null,
            feedback: null,
            show: false,
            type: 'password'
        },
        alertVariant: 'primary',
        alertMessage: '',
        disabledPwd: true
    }
  },
  computed: {
    user() {
        let user = Store.getters.getUser()
        switch (user.gender) {
            case 'FEMALE':
                user.gender = 'Madame'
                break
            case 'MALE':
                user.gender = 'Monsieur'
        }
        user.birth_date = user.birth_date.split(' ')[0].split('-')
        user.birth_date = user.birth_date[2] + '/' + user.birth_date[1] + '/' + user.birth_date[0]
        return user
    },
  },
  beforeCreate() {
    this.$parent.$parent.setLoading(true, "Chargement de vos informations")
    api.get('/user/')
    .then(response=> {
      if (response.data[0].email) {
          this.accountForm.email = response.data[0].email
          this.disabledPwd = false
      }
      this.$parent.$parent.setLoading(false)
    })
  },
  mounted() {
    this.accountForm.email = this.user.email
  },
}
</script>

<style scoped>
h1 {
  font-weight: bold;
  margin-bottom: 20px;
}
form {
    font-weight: bold;
}
.form-group {
    margin-bottom: 20px;
}
.alert-box {
    margin-top: 1.5rem;
    z-index: 1;
}
.user-identity {
    text-align: left;
}
.user-identity>.row {
    margin: 1em auto;
}
.user-label {
    font-weight: bold;
}
.text-muted {
    color: #000000 !important;
}
.pwd-field {
  display: flex;
}
.input {
  margin-right: 5px
}
#db-btn {
    margin: 1.5em auto 0;
}
#edit-personal-infos {
    margin: 1.5em auto 0;
}
#db-btn>a {
    margin-bottom: 0;
}
.container>.row>div {
    margin-bottom: 2em
}
</style>